import  { useEffect, useState } from "react";
import "./TenthReport.css";

const QTag = ({ q, a, impacts }) => (
  <div style={{display:'flex',flexWrap:'wrap',gap:'5px 10px',alignItems:'center',background:'#f0f4ff',border:'1px solid #c7d7fa',borderRadius:'6px',padding:'7px 12px',marginBottom:'12px',fontSize:'12px',lineHeight:1.5}}>
    <span style={{background:'#3b5bdb',color:'#fff',fontWeight:700,padding:'2px 8px',borderRadius:4,fontSize:'10px',whiteSpace:'nowrap'}}>📋 FORM QUESTION</span>
    <span style={{color:'#1e3a8a',fontStyle:'italic'}}>"{q}"</span>
    <span style={{color:'#6b7280',fontSize:'11px'}}>→</span>
    <span style={{color:'#047857',fontWeight:700}}>You answered: <strong>{a}</strong></span>
    <span style={{color:'#6b7280',fontSize:'11px'}}>→</span>
    <span style={{color:'#7c3aed',fontSize:'11px'}}>📊 Impacts: {impacts}</span>
  </div>
);

const TenthReport = ({ res }) => {
  const [adopt20Value, setAdopt20Value] = useState("");
  const [legalValue, setLegalValue] = useState("");
  const [marketingValue, setMarketingValue] = useState("");
  const [ideaValue, setIdeaValue] = useState("");
  const [investorFitValue, setInvestorFitValue] = useState("");

  useEffect(() => {
    if (res) {
      const clean = (val) => val?.replace(/[^A-Za-z0-9 ]/g, "") || "";

      setAdopt20Value(clean(res.adopt20));
      setLegalValue(clean(res.legal));
      setMarketingValue(clean(res.marketing));
      setIdeaValue(clean(res.idea));
      setInvestorFitValue(res.investorFit || "");
    }
  }, [res]);

  // ================= 9 A =================
  const adoptContent =
    adopt20Value.toLowerCase() === "yes"
      ? "Believing deeply in our idea makes us resilient, mission-driven, and aligned with user reality — a trait investors trust for long-term scalability."
      : "You’ll rebuild belief through direct validation, user immersion, and iterative learning — ensuring our conviction is grounded in real market insight.";

  // ================= 9 B =================
  const legalContent =
    legalValue.toLowerCase() === "yes"
      ? "Our product aligns with both legal standards and user expectations — building trust, reducing risk, and strengthening long-term investor confidence."
      : "We’ll prioritize compliance, transparency, and user-centric redesign to ensure legal safety and customer trust — creating a stronger foundation for investor readiness.";

  // ================= 9 C =================
  const marketingContent =
    marketingValue.toLowerCase() === "yes"
      ? "Marketing challenges are signals, not setbacks — they help refine our audience, sharpen messaging, and regain traction through focused execution."
      : "Proven marketing traction validates our product-market fit, accelerates investor confidence, and sets a clear path for scalable growth.";

  // 🔥 ================= 9 E =================
  const ideaContent =
    ideaValue.toLowerCase() === "yes"
      ? "Adopting an entrepreneurial mindset makes us adaptable, visionary, and resilient — the kind of founders investors trust to lead through any market condition."
      : "We’ll actively cultivate entrepreneurial mindsets through mentorship, reflection, and disciplined learning — ensuring long-term growth and investor confidence.";

  // ================= 9 D (Investor Fit) =================
  const investorFitContent =
    investorFitValue.toLowerCase() === "stage"
      ? "Represents how mature the startup is and whether it fits the investment stage an investor supports. Strong stage alignment increases funding readiness, reduces risk, and signals that the startup is at the right maturity level for growth."
      : "Shows the value and change the startup can create for users, markets, or society. High-impact ideas attract interest, but investors prefer them when paired with solid stage readiness and measurable traction.";

  return (
    <div style={{ padding: "22px" }}>
      <div className="tenth-module-container">
        <h3 className="module-title"> <span className="module-prefix">Module 9:</span>  Acceptability</h3>
        <QTag
          q="Do you believe your target market will adopt your idea? Is your product legally compliant, and what type of investor are you targeting?"
          a={`Market adoption belief: ${adopt20Value.toLowerCase() === "yes" ? "Yes" : "No"} · Legal compliant: ${legalValue.toLowerCase() === "yes" ? "Yes" : "No"} · Investor fit: ${investorFitValue || "—"} · Entrepreneurial mindset: ${ideaValue.toLowerCase() === "yes" ? "Yes" : "No"}`}
          impacts="Market readiness score, legal risk level, investor type alignment, founder mindset credibility"
        />
        {/* Corner Borders */}
        <span className="corner9 top-left"></span>
        <span className="corner9 top-right"></span>
        <span className="corner9 bottom-left"></span>
        <span className="corner9 bottom-right"></span>

        {/* 9 A */}
        {adopt20Value && (
          <table className="tenth-module-table">
            <tbody>
              <tr>
                <td className="serial-cell">9 A</td>
                <td>{adopt20Value.toLowerCase() === "yes" ? "Yes" : "No"}</td>
                <td>{adoptContent}</td>
              </tr>
            </tbody>
          </table>
        )}

        {/* 9 B */}
        {legalValue && (
          <table className="tenth-module-table">
            <tbody>
              <tr>
                <td className="serial-cell">9 B</td>
                <td>{legalValue.toLowerCase() === "yes" ? "Yes" : "No"}</td>
                <td>{legalContent}</td>
              </tr>
            </tbody>
          </table>
        )}

        {/* 9 C */}
        {marketingValue && (
          <table className="tenth-module-table">
            <tbody>
              <tr>
                <td className="serial-cell">9 C</td>
                <td>{marketingValue.toLowerCase() === "yes" ? "Yes" : "No"}</td>
                <td>{marketingContent}</td>
              </tr>
            </tbody>
          </table>
        )}

        {/* 9 D - Investor Fit */}
        {investorFitValue && (
          <table className="tenth-module-table">
            <tbody>
              <tr>
                <td className="serial-cell">9 D</td>
                <td>{investorFitValue.toLowerCase() === "stage" ? "Stage" : "Impact"}</td>
                <td>{investorFitContent}</td>
              </tr>
            </tbody>
          </table>
        )}

        {/* 🔥 9 E */}
        {ideaValue && (
          <table className="tenth-module-table">
            <tbody>
              <tr>
                <td className="serial-cell">9 E</td>
                <td>{ideaValue.toLowerCase() === "yes" ? "Yes" : "No"}</td>
                <td>{ideaContent}</td>
              </tr>
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default TenthReport;
